module.exports = __webpack_public_path__ + "img/cv-template-13.aefa560c.png";